import React from 'react';

import { Link } from '@mui/material';
import { FormikProps } from 'formik';
import { HelpTypes } from '@pharmaplan/common';

import { Constants, InputTypes } from '../../../../helpers/Constants';
import CustomDatePicker from '../../../common/CustomDatePicker';
import { serverToday } from '../../../../helpers/Functions';
import strings from '../../../../localization';

import styles from './styles';

const { text, component } = Constants.formInputType;
const serverDate = serverToday();

export const campaignFieldConfig = (formik: FormikProps<any>, isEdit:boolean) => {
  const isPharmacy = formik.values.userType === HelpTypes.pharmacy;
  return [
    {
      xs: 3,
      key: '1',
      name: 'name',
      label: strings.campaignName,
      type: text,
      requireLabel: true,
      placeholder: ' ',
      customTextFieldContainer: styles.fieldContainer,
    },
    {
      xs: 3,
      key: 'userType',
      name: 'userType',
      label: strings.userType,
      disabled: isEdit,
      type: Constants.formInputType.dropdown,
      menuItems: [
        { key: HelpTypes.pharmacy, label: strings.pharmacy },
        { key: HelpTypes.pharmacist, label: strings.pharmacist },
        { key: HelpTypes.technicians, label: strings.technicians },
      ],
      requireLabel: true,
      customTextFieldContainer: styles.fieldContainer,
    },
    {
      xs: 3,
      key: '2',
      name: isPharmacy ? 'promoHourlyRate' : 'hourlyRateBonus',
      label: isPharmacy ? strings.promoHourlyRate : strings.promoHourlyBonus,
      type: text,
      customType: InputTypes.number,
      requireLabel: true,
      placeholder: ' ',
      customTextFieldContainer: styles.fieldContainer,
    },
    isPharmacy && {
      xs: 3,
      key: '6',
      name: 'remotePromoHourlyRate',
      label: strings.remotePromoHourlyRate,
      type: text,
      customType: InputTypes.number,
      placeholder: ' ',
      infoText: strings.promoRateAppliedEmpty,
      customTextFieldContainer: styles.fieldContainer,
    },
    {
      xs: 3,
      key: '3',
      name: 'creditShiftCount',
      label: strings.totalCredits,
      type: text,
      customType: InputTypes.number,
      requireLabel: true,
      placeholder: ' ',
      customTextFieldContainer: styles.fieldContainer,
    },
    {
      xs: 6,
      key: '5',
      type: Constants.formInputType.datePicker,
      dateStartLabel: strings.campaignStartDate,
      dateEndLabel: strings.campaignEndDate,
      preventPast: true,
      hideErrors: true,
    },
    {
      xs: 3,
      key: '4',
      name: 'validityInDays',
      label: strings.creditValidityInDays,
      type: component,
      renderComponent: () =>
        (
          <CustomDatePicker
            required
            label={strings.creditsValidUntil}
            name="validityInDays"
            minDate={formik.values?.endDate ?? serverDate}
            readOnly
            error={
          (formik.touched.validityInDays
            && formik.errors.validityInDays) as string
        }
            formik={formik}
          />
        ),
    },
  ].filter(Boolean) as any[];
};

const currentScreen = (
  <Link
    key="curr"
    href={Constants.paths.admin.campaigns}
    sx={[styles.noUnderline, styles.prevLink]}
  >
    {strings.campaigns}
  </Link>
);

export const createCrumbs = [
  currentScreen,
  <Link
    href={Constants.paths.admin.createCampaign}
    sx={styles.noUnderline}
    key="create"
  >
    {strings.createCampaign}
  </Link>,
];

export const editCrumbs = [
  currentScreen,
  <Link
    href={Constants.paths.admin.editCampaign}
    sx={styles.noUnderline}
    key="edit"
  >
    {strings.editCampaign}
  </Link>,
];
